import {
  UPDATE_FORM_REQUEST,
  UPDATE_FORM_SUCCESS,
  UPDATE_FORM_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  success: false,
  error: null,
  updatedForm: null,
};

const UpdateFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case UPDATE_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        updatedForm: action.payload,
      };

    case UPDATE_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default UpdateFormReducer;
